import * as Sentry from '@sentry/browser';
import { environment } from './environments/environment';

declare const BUILD_DATETIME: string;

const tracing = [/api/];

export default function makeSentry() {
  Sentry.init({
    enabled: process.env.NODE_ENV === 'production',
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    release: typeof BUILD_DATETIME !== 'undefined' ? BUILD_DATETIME : undefined,
    tracesSampleRate: 1.0,
    tracePropagationTargets: tracing,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'Object captured as exception with keys: err, status, statusText', // скорее всего из-за того что в catchBadResponse (ExceptionService) мы возвращаем объект с ошибкой
      'Handled unknown error', // не совсем понятно от чего происходит, но точно что-то связанное с запросом в сеть. я словил на ошибке err_insufficient_resources
      '<unknown>', // скорее всего из-за silent renew от oidc
    ]
  });

  if (environment.sentry.environment === 'prod') {
    Sentry.addIntegration(
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        networkDetailAllowUrls: tracing,
        networkRequestHeaders: ['baggage', 'sentry-trace'],
      })
    );
  }

  window.Sentry = Sentry;
}

export function defineUser(user: any) {
  const replay = Sentry.getClient()?.getIntegrationByName?.<ReturnType<typeof Sentry.replayIntegration>>('Replay');

  if (user) {
    Sentry.setUser({ id: user.email, email: user.email });

    if (environment.sentry.environment === 'prod' && !replay?.getReplayId()) {
      replay?.start();
    }
  } else {
    void replay?.stop();
  }
}

export const sentryClient = Sentry;
